import { render, staticRenderFns } from "./vote.vue?vue&type=template&id=670bdfc6"
import script from "./vote.vue?vue&type=script&lang=js"
export * from "./vote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports